import React, { useState, useEffect } from 'react';

import { Form, Input, notification, Spin } from 'antd';

import MaskedInput from 'antd-mask-input';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';


export default ({form}) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [value, setValue] = useState(null);

    useEffect(()=> {
        load(form.getFieldsValue().postal_code);
    }, [form.getFieldsValue().postal_code]);

    useEffect(()=> {
        if (data != null || value != null) {
            form.validateFields(['postal_code']);
        }
    }, [data]);

    const intl = useIntl();

    const load = (changedValue) => {
        if (changedValue) {
            setLoading(true);
            _service({
                url:'postal-code',
                data: {value: changedValue},
                success: (response) => {
                    setData(response.json);
                    setLoading(false);
                },
                fail: (e) => {
                    setLoading(false);
                    setData(null);
                    notification["error"]({
                        message: 'Não foi possivel carregar os dados do código postal.',
                        description: e.response.json.error,
                    });
                }
            });
        }
    };

    const onPostalCodeChange = (input)=> {
        const changedValue = input.target.value;
        if (/^[0-9]{4}-[0-9]{3}$/.test(changedValue)) {
            load(changedValue);
        } else {
            setData(null);
            setValue(value);
        }
    };
    let info = null;
    let extra = null;
    if (data) {
        info = (
           <div style={{ padding:'10px'}}>
              {(data.artery && data.artery.place) || data.locality.name}, {data.county.name}, {data.district.name}, {data.address} 
            </div>
        );
        extra = (
            <>
              {data.artery &&
               <>
                 <Form.Item 
                   name={'address_extra'} 
                   label="Complemento" 
                   noStyle
                   rules={[
                       { required: true, message: 'Insira o complemento.'}
                   ]}
                 >
                   <Input placeholder="Complemento..." style={{ width: '150px' }} />
                 </Form.Item>
               </>
              }
            </>
        );
    }
    return (
          <Form.Item 
            name={'address'} 
            label={intl.formatMessage({id: 'components.address-fields.title'})}
            required
          >
            <Form.Item 
              name={'postal_code'} 
              label={intl.formatMessage({id: 'reserved-area.construction.fields.postal-code'})} 
              noStyle
              rules={[
                  { pattern: /^[0-9]{4}-[0-9]{3}$/,  message: 'Insira o código postal correto.'},
                  { validator: 
                    (rule, value) => {
                        if (data == null) {
                            return Promise.reject('Código postal não carregado.');
                        }
                        return Promise.resolve();
                    }
                  },
              ]}
            >
              <MaskedInput mask="1111-111" size="8" style={{ width: '100px' }} onChange={onPostalCodeChange}/>
            </Form.Item>
            {loading && <>&nbsp; <Spin size="small" /></>}
            {info}
            {extra}
          </Form.Item>
    );
};
